import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { type Search } from '@vakantiesnl/types';
import dayjs from 'dayjs';

import { useStyles } from './FlightTransfer.styles';
import { FlightTransferSegments } from './FlightTransferSegments';

export type Props = {
	flight: Search.Flight;
	isOutbound: boolean;
};

export const FlightTransfer: FC<Props> = ({ flight, isOutbound }) => {
	const { classes } = useStyles();
	const microCopies = useMicroCopyContext();

	return (
		<div className={classes.transferFlightContainer}>
			{flight.flightSegments && flight.flightSegments.length > 1 && (
				<div className={classes.transferFlight}>
					<Typography variant="headingSm" as="h5">
						{isOutbound
							? microCopies['accommodation.flight.transfer_outbound_title']
							: microCopies['accommodation.flight.transfer_inbound_title']}{' '}
						{dayjs(flight.departureDateTime).format('DD-MM-YYYY')}
					</Typography>
					<FlightTransferSegments flight={flight} />
				</div>
			)}
		</div>
	);
};
